import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function SubscriptionCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6">
      <div className="noise-overlay" />
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center max-w-md"
      >
        <div className="w-24 h-24 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-red-500" />
        </div>
        <h1 className="text-3xl font-black mb-4">Payment Cancelled</h1>
        <p className="text-zinc-400 mb-8">
          Your payment was cancelled. No charges were made. Ready to try again?
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={() => navigate('/subscription')}
            className="bg-[#CCFF00] text-black hover:bg-[#B3E600] font-bold rounded-full px-8"
            data-testid="try-again-btn"
          >
            Try Again
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/dashboard')}
            className="border-zinc-700 rounded-full px-8"
            data-testid="go-dashboard-btn"
          >
            Back to Dashboard
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
